export enum LayoutsEnum {
  Default = 'default',
  Admin = 'admin',
  AdminDefault = 'admin-default',
  Auth = 'auth',
  Preview = 'preview',
}
